import { Asset } from 'contentful';

export interface ImageData {
  sysId: string;
  src: string;
  contentType: string;
  alt: string;
  width: number;
  height: number;
}

export const getImageData = (asset: Asset): ImageData => {
  const { sys, fields } = asset ?? {};

  return {
    sysId: sys?.id ?? '',
    src: fields?.file?.url ?? '',
    contentType: fields?.file?.contentType ?? '',
    alt: fields?.description ?? 'Greenlight image',
    width: fields?.file?.details?.image?.width ?? 1,
    height: fields?.file?.details?.image?.height ?? 1
  };
};
